import { dataImageStarSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconImageStarSolid = /*#__PURE__*/createIcon(dataImageStarSolid)
export default IconImageStarSolid
